import { MultiString } from "../../../library-js/i18n/MultiString";

export class AppLocales
{
  static readonly File:MultiString = { en:"File", de:"Datei" };
  static readonly NewFile:MultiString = { en: "New File", de:"Neu Datei" };
  static readonly OpenFile:MultiString = { en: "Open File", de: "Datei öffnen" };

  static readonly Project:MultiString = { en:"Project", de:"Projekt" };
  static readonly NewProject:MultiString = { en: "New Project", de:"Neues Projekt" };
  static readonly OpenProject:MultiString = { en: "Open Project", de: "Projekt öffnen" };

  static readonly Edit:MultiString = { en:"Edit", de:"Bearbeiten" };
  static readonly Undo:MultiString = { en: "Undo", de:"Rückgängig" };
  static readonly Redo:MultiString = { en: "Redo", de: "Wiederholen" };

  static readonly View:MultiString = { en:"View", de:"Ansicht" };

  static readonly Audio:MultiString = { en:"Audio", de:"Audio" };

  static readonly Export:MultiString = { en:"Export", de:"Export" };
}